const trustItems = [
  { icon: 'ri-flashlight-line', title: 'Fast Response', desc: 'We respond to all placement inquiries within one business day — often within hours.' },
  { icon: 'ri-message-2-line', title: 'Transparent Communication', desc: 'Regular updates on progress, challenges, and milestones throughout the placement.' },
  { icon: 'ri-team-line', title: 'Collaborative Planning', desc: 'We work alongside your team to align goals, coordinate strategies, and share insights.' },
  { icon: 'ri-notification-3-line', title: 'Immediate Incident Notification', desc: 'You will be notified immediately of any significant incidents as they occur.' },
  { icon: 'ri-user-settings-line', title: 'Individualized Programming', desc: 'No two youth receive the same plan. Every placement is uniquely designed.' },
  { icon: 'ri-file-text-line', title: 'Reliable Documentation', desc: 'Thorough, transparent reporting on progress, incidents, and milestones.' },
  { icon: 'ri-star-line', title: 'Responsive Leadership', desc: 'Direct access to decision-makers who can make things happen quickly.' },
  { icon: 'ri-shuffle-line', title: 'Flexible Placements', desc: 'We adapt to the needs of the youth and the requirements of your agency.' },
];

export default function AgencyTrustSection() {
  return (
    <section id="agency-trust" className="py-24 md:py-32 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16 md:mb-20">
          <span className="inline-block bg-secondary-100 text-secondary-800 text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wider label-font mb-5">
            For Placing Agencies
          </span>
          <h2 className="heading-font text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 max-w-3xl mx-auto leading-tight">
            Why Agencies <span className="italic text-primary-600">Trust</span> MCT
          </h2>
          <p className="text-foreground-600 mt-5 max-w-2xl mx-auto leading-relaxed text-base md:text-lg">
            Placement workers deserve responsive, reliable partners. Here&apos;s what you can expect when you work with us.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {trustItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-secondary-300 transition-all duration-300 cursor-default"
            >
              <span className="w-12 h-12 flex items-center justify-center bg-secondary-100 text-secondary-700 rounded-xl mb-4 group-hover:bg-secondary-200 transition-colors">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="font-semibold text-foreground-900 mb-2 label-font text-sm">{item.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}